import { useMemo } from 'react';
import { useLogisticsById } from '@/queries/route-planner';
import { RouteTypeEnum } from '@/api/apis/route';
import { getRouteLegsDivided } from '@/queries/route-planner/utils';
import { getRouteProviders } from '@/utils/helpers';

export const useLogisticsProviders = (logisticsReferenceId?: string) => {
  const { data: logisticsProjection, isLoading, error } = useLogisticsById(logisticsReferenceId);

  const providers = useMemo(() => {
    if (!logisticsProjection) return [];

    const mainRoute = logisticsProjection.routes.find((r) => r.routeType === RouteTypeEnum.Main);
    if (!mainRoute) return [];

    const { legs } = getRouteLegsDivided(mainRoute.legs, logisticsProjection.locations);

    return getRouteProviders(legs);
  }, [logisticsProjection]);

  return { providers, isLoading, error };
};
